import { Column, ModelBase } from 'loca-boot-core'
/**
 * 指标项
 */
export class IndicatorItemModel extends ModelBase {
  /**
   * 一二级指标： eg.indicator_so_service_count
   */
  @Column()
  public indicatorCode!: string

  /**
   * 指标值 eg.10000
   */
  @Column()
  public indicatorValue!: string | number

  /**
   * 维度： eg.区域：region_code
   */
  @Column()
  public dimCode!: string

  /**
   * 维度值： eg.all
   */
  @Column()
  public dimValue!: string
}
